import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'

import { useParams } from 'next/navigation'
import {
  QUERY_MEMBERSHIP_DETAIL_KEY,
  fetchMembershipDetail,
} from './fetchMembershipDetail'
import useAuthentication from '../useAuthentication'
import type { MembershipDetailModel } from 'core/profile/types'

function useQueryMembershipDetail(): UseQueryResult<MembershipDetailModel | null> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { isAuthenticated, withSmartclubApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [QUERY_MEMBERSHIP_DETAIL_KEY, { locale }],
    queryFn: withSmartclubApiRequest(fetchMembershipDetail),
    enabled: isAuthenticated,
  })
}

export default useQueryMembershipDetail
